var _path, _path2, _circle, _circle2, _circle3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembersPageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 25,
    viewBox: "0 0 43 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.0001C6.1 8.80005 1.33333 15.3334 0 19.0001C2.8 17 6 18.0001 6 19.5001V24.5001H12.5V16.5001C12.5 14.1001 13.8333 12.5001 14.5 12.0001Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12.0001C36.4 8.80005 41.1667 15.3334 42.5 19.0001C39.7 17 36.5 18.0001 36.5 19.5001V24.5001H30V16.5001C30 14.1001 28.6667 12.5001 28 12.0001Z",
    fill: "#ECECEC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 3.5,
    fill: "#ECECEC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 3.5,
    r: 3.5,
    fill: "#ECECEC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 6.5,
    r: 3.5,
    fill: "#ECECEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15V24.5H25V15C25 10.2 30.3333 9.66664 33 9.99998C31.8333 9.33332 27.9 8 21.5 8C15.1 8 11.1667 9.33332 10 9.99998C16 9.19998 17.5 13 17.5 15Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersPageIcon);
export default __webpack_public_path__ + "static/media/members-page-icon.a5d216d5b1ab97b155849967f6957c11.svg";
export { ForwardRef as ReactComponent };